import "../aboutModal/about.scss";

import PropTypes from "prop-types";
import PubSub from "pubsub-js";
import React, { PureComponent } from "react";
import { connect } from "react-redux";

import { version } from "../../../jsAppVersion";
import FormButton from "../../components/form/FormButton";
import ModalTabContent from "../../components/modal/ModalTabContent";
import PubSubTopics from "../../constants/pubSubTopics";
import { autoUpdatesSelectors } from "../../modules/autoUpdates";
import { nativeCommsBroadcastMessageTypes } from "../../nativeComms";
import preprocessorQuery from "../../utils/preprocessorQuery";

class SettingsIosAboutGroup extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      copied: false
    };
    this.onCopyClipboardClick = this.onCopyClipboardClick.bind(this);
    this._copySuccessTimerId = null;
  }

  componentWillUnmount() {
    if (this._copySuccessTimerId) {
      window.clearTimeout(this._copySuccessTimerId);
    }
  }

  onCopyClipboardClick() {
    const mode = preprocessorQuery.isReadonly() ? "Read-only" : "Editor";

    PubSub.publish(PubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.ABOUT_COPY_TO_CLIPBOARD,
      version,
      shellVersion: this.props.shellVersion,
      mode
    });
    this.setState({ copied: true });
    this._copySuccessTimerId = window.setTimeout(() => {
      this._copySuccessTimerId = null;
      this.setState({ copied: false });
    }, 2000);
  }

  render() {
    let readonlyLabel = null;
    //#!if readonly === true
    readonlyLabel = "Operating in read-only mode";
    //#!endif

    const contentStyle = {
      marginBottom: "20px"
    };

    const copiedClass = `copyResult ${this.state.copied ? "copySuccess" : ""}`;

    return (
      <ModalTabContent>
        <div className="aboutModalContent" style={contentStyle}>
          <img className="appIcon" src={require("../../images/AppIcon.png")} />
          <h1>Aeon Timeline</h1>
          <div>Version: {version}</div>
          <div>Shell: {this.props.shellVersion ? this.props.shellVersion : "Unknown"}</div>
          {readonlyLabel ? <div style={{ marginTop: "5px" }}>{readonlyLabel}</div> : null}
          <FormButton
            className="copyBtn"
            style={{ marginTop: "10px" }}
            label="Copy Version &amp; Operating System"
            linkStyle={true}
            onClick={this.onCopyClipboardClick}
          />
          <div className={copiedClass}>Copied to clipboard!</div>
        </div>
      </ModalTabContent>
    );
  }
}

SettingsIosAboutGroup.propTypes = {
  shellVersion: PropTypes.string
};

const mapStateToProps = state => {
  return {
    shellVersion: autoUpdatesSelectors.getCurrentShell(state.present)
  };
};

export default connect(mapStateToProps, null)(SettingsIosAboutGroup);
